import * as commonScripts from '../common'
import Glide from '@glidejs/glide'

const cmpAwardsCarousel = {
  component: null,

  init: function (element) {
    const _ = this
    _.component = element
    commonScripts.util.animationTranslate(this)
    commonScripts.util.inheritPermalink(element)
    // If not in edit mode, then initialize the carousel
    if (!commonScripts.util.isEditMode()) {
      const carouselId = _.component.getAttribute('data-carousel-id')
      const carouselDiv = _.component.querySelector(
        '#' + carouselId + ' .glide'
      )
      const slidesAmount = carouselDiv.querySelectorAll('.glide__slide').length

      if (carouselDiv) {
        const options = {}
        options.rewind = false
        options.perView = 3
        options.bound = true
        options.gap = 32
        options.breakpoints = {
			767: {
				perView: 1
			},
			1023: {
				perView: 2
			}
        }
        const glide = new Glide(carouselDiv, options)

        glide.mount()

		// determines how many clicks are required before the navigation button becomes disabled
        const slideOffsetMobile = carouselDiv.querySelector('.mobile').getAttribute('slide-offset') ?? 2
        const slideOffsetTablet = carouselDiv.querySelector('.tablet').getAttribute('slide-offset') ?? 3
        const slideOffsetDesktop = carouselDiv.querySelector('.desktop').getAttribute('slide-offset') ?? 4

        let currentSlide = null
        glide.on('move.after', function () {
          // prevents re-render when click on any part of carousel.
          if (currentSlide === glide.index) return
          currentSlide = glide.index

          const firstSlide = 0

          const lastSlideMobile = slidesAmount - slideOffsetMobile 
          const lastSlideTablet = slidesAmount - slideOffsetTablet 
          const lastSlideDesktop = slidesAmount - slideOffsetDesktop 

          const arrowLeftMobile = carouselDiv.querySelector(
            '.mobile .glide__arrow--left'
          )
          const arrowRightMobile = carouselDiv.querySelector(
            '.mobile .glide__arrow--right'
          )

          const arrowLeftTablet = carouselDiv.querySelector(
            '.tablet .glide__arrow--left'
          )
          const arrowRightTablet = carouselDiv.querySelector(
            '.tablet .glide__arrow--right'
          )

          const arrowLeftDesktop = carouselDiv.querySelector(
            '.desktop .glide__arrow--left'
          )
          const arrowRightDesktop = carouselDiv.querySelector(
            '.desktop .glide__arrow--right'
          )

          handleArrows(
            arrowLeftMobile,
            arrowRightMobile,
            currentSlide,
            firstSlide,
            lastSlideMobile
          )
		  handleArrows(
            arrowLeftTablet,
            arrowRightTablet,
            currentSlide,
            firstSlide,
            lastSlideTablet
          )
          handleArrows(
            arrowLeftDesktop,
            arrowRightDesktop,
            currentSlide,
            firstSlide,
            lastSlideDesktop
          )
        })
      }
    }
    function handleArrows (
      arrowLeft,
      arrowRight,
      currentSlide,
      firstSlide,
      lastSlide
    ) {
      if (currentSlide === firstSlide) {
        disable(arrowLeft)
        enable(arrowRight)
      }
      if (currentSlide > firstSlide && currentSlide < lastSlide) {
        enable(arrowLeft)
        enable(arrowRight)
      }
      if (currentSlide === lastSlide) {
        enable(arrowLeft)
        disable(arrowRight)
      }
    }
    function disable (arrow) {
      arrow.disabled = true
    }
    function enable (arrow) {
      arrow.disabled = false
    }
  }
}

export default cmpAwardsCarousel
